export default __webpack_public_path__ + "static/media/j16.561d8c19.jpg";